export default function incentivePerformancesReducer(
  state = {
    incentives: [],
    correctToDate: '',
    fetching: false,
    fetched: false,
    errors: {}
  },
  action
) {
  switch (action.type) {
    case 'ACCOUNT_MANAGER_INCENTIVE_PERFORMANCES_PENDING':
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    case 'ACCOUNT_MANAGER_INCENTIVE_PERFORMANCES_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        incentives: action.payLoad.data,
        correctToDate: action.payLoad.meta['correct-to-date'],
      }
    case 'ACCOUNT_MANAGER_INCENTIVE_PERFORMANCES_REJECTED':
      // return {...state, errors: action.payLoad.errors || {}}
    default: {
      return {...state};
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/incentivePerformancesReducer.js